import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "k-link k-menu-link" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drop_down_button = _resolveComponent("drop-down-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_drop_down_button, {
      id: "ddbLanguage",
      items: _ctx.dataItems,
      imageUrl: _ctx.iconPathSelectedLanguage,
      "item-render": "itemRender",
      onItemclick: _ctx.onLanguageSelect,
      "button-class": "btn-language icon-button",
      "fill-mode": "outline"
    }, {
      itemRender: _withCtx(({props}) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.iconPath(props.item.language),
            class: "flag"
          }, null, 8, _hoisted_2),
          _createTextVNode("  " + _toDisplayString(props.item.title), 1)
        ])
      ]),
      _: 1
    }, 8, ["items", "imageUrl", "onItemclick"])
  ]))
}